import { FC } from 'react';
import { IconWrapper } from '../IconWrapper';
import { IconProps } from '../Icons.types';

const WarningCircleFilled: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName='WarningCircleFilled'
      icon={
        <svg
          width='inherit'
          height='inherit'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...props}
        >
          <path
            d='M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21508 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.807 7.51472 24.4853C9.19295 26.1635 11.3311 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0865C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6934 28 18.3734 28 16C27.9966 12.8184 26.7313 9.76814 24.4816 7.51843C22.2319 5.26872 19.1816 4.00336 16 4ZM15.0769 10.4615C15.0769 10.2167 15.1742 9.98193 15.3473 9.80882C15.5204 9.63571 15.7552 9.53846 16 9.53846C16.2448 9.53846 16.4796 9.63571 16.6527 9.80882C16.8258 9.98193 16.9231 10.2167 16.9231 10.4615V16.9231C16.9231 17.1679 16.8258 17.4027 16.6527 17.5758C16.4796 17.7489 16.2448 17.8462 16 17.8462C15.7552 17.8462 15.5204 17.7489 15.3473 17.5758C15.1742 17.4027 15.0769 17.1679 15.0769 16.9231V10.4615ZM16 22.4615C15.7262 22.4615 15.4585 22.3803 15.2308 22.2282C15.0031 22.076 14.8256 21.8598 14.7208 21.6068C14.616 21.3538 14.5886 21.0754 14.642 20.8068C14.6954 20.5382 14.8273 20.2915 15.0209 20.0978C15.2146 19.9042 15.4613 19.7723 15.7299 19.7189C15.9985 19.6655 16.2769 19.6929 16.5299 19.7977C16.7829 19.9025 16.9991 20.08 17.1513 20.3077C17.3034 20.5354 17.3846 20.8031 17.3846 21.0769C17.3846 21.4441 17.2387 21.7963 16.9791 22.056C16.7194 22.3157 16.3672 22.4615 16 22.4615Z'
            fill='currentColor'
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default WarningCircleFilled;
